module.exports = __webpack_public_path__ + "img/img01.7165d17e.png";